module.exports = __webpack_public_path__ + "img/detailVote.c70ad61a.png";